import './claim-entity.page.container.scss';

import { Box, Stack, Typography } from '@mui/material';

import { ReactNode } from 'react';
import { config } from '@converge/config';
import { ConvergeEnv } from '@converge/data';

interface ClaimEntityPageContainerProps {
  title: string;
  description?: string;
  className?: string;
  titleChildren?: ReactNode;
  children: ReactNode;
}

export const ClaimEntityPageContainer = ({
  title,
  children,
  description,
  className,
  titleChildren,
}: ClaimEntityPageContainerProps) => {
  const envClass =
    config.convergeEnv === ConvergeEnv.Staging ||
    config.convergeEnv === ConvergeEnv.Development
      ? config.convergeEnv
      : '';

  return (
    <Box className={`claim-entity-page-container ${className}`}>
      <Stack
        alignItems="left"
        className={`claim-entity-page-header ${envClass}`}
      >
        <Typography variant="h5" className="main-contact-title">
          {title}
        </Typography>
        {description && (
          <Box
            style={{
              backgroundColor: 'white',
              paddingBottom: `${titleChildren ? '0px' : '20px'}`,
            }}
          >
            {description}
          </Box>
        )}
        {titleChildren && <Box>{titleChildren}</Box>}
      </Stack>
      <Box
        className={`claim-entity-page-content ${description ? '' : 'mt-120'}`}
      >
        {children}
      </Box>
    </Box>
  );
};
